import { render, staticRenderFns } from "./SelfServiceDashboard.vue?vue&type=template&id=7b2cab96&scoped=true&"
import script from "./SelfServiceDashboard.vue?vue&type=script&lang=js&"
export * from "./SelfServiceDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SelfServiceDashboard.vue?vue&type=style&index=0&id=7b2cab96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2cab96",
  null
  
)

export default component.exports